

import React, { memo } from 'react';
import cx from 'classnames';
import { Icon, Button } from '../../ui-kit';

import './styles/_payment-event-status.scss';













const getStatusStyles = (className, { success, fail, warning }) => cx(className,
{
  [`${className}--success`]: success,
  [`${className}--fail`]: fail,
  [`${className}--warning`]: warning
}
);

function getIconProps(success, fail, warning) {
  if (success) {
    return { name: 'success', color: 'monkey' };
  }

  if (fail) {
    return { name: 'alert', color: 'thunderBird' };
  }

  if (warning) {
    return { name: 'alert', color: 'goldenTainoi' };
  }

  return { name: 'alert', color: 'thunderBird' };
}

function PaymentEventStatus({
  success = false,
  fail = false,
  warning = false,
  title,
  highlight,
  description,
  buttonText,
  onClick
}) {
  return (
    <div className={getStatusStyles('payment-event-status', { success, fail, warning })}>
      <div className="payment-event-status__icon">
        <Icon {...getIconProps(success, fail, warning)} size={16} />
      </div>
      <div className="payment-event-status__contents">
        <div className="payment-event-status__contents__title">
          {title}
          {highlight &&
          <span className={getStatusStyles('payment-event-status__contents__title__highlight', { success, fail, warning })}>
              {` ${highlight}`}
            </span>}

        </div>
        <div className="payment-event-status__description">{description}</div>
      </div>
      {buttonText && onClick &&
      <div className="payment-event-status__action">
          <Button className="payment-event-status__action__button" type="TERTIARY" onClick={onClick}>{buttonText}</Button>
        </div>}

    </div>);

}

export default memo(PaymentEventStatus);